import { ref} from "vue";

export function usePayslipEnums() {

    const payslipEnums = ref({
        UNVALIDATED: 'UNVALIDATED',
        VALIDATED: 'VALIDATED',
    })

    const pensionTypesEnums = ref({
        EMPLOYER_PENSION: 'EMPLOYER_PENSION',
        EMPLOYEE_PENSION: 'EMPLOYEE_PENSION'
    })

    const payrollTaxStatusEnums = ref({
        EMPLOYER_TAXE: 'EMPLOYER_TAXE',
        EMPLOYEE_TAXE: 'EMPLOYEE_TAXE'
    })


    return { payslipEnums, pensionTypesEnums, payrollTaxStatusEnums }
}
